import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {DASH, formatDateTime} from '../../helpers/format'

/**
 * Thời gian — 2 dòng: dòng trên là thời gian TƯƠNG ĐỐI ("2 giờ trước"), dòng dưới là mốc tuyệt đối
 * `DD/MM/YYYY HH:mm` (đã có sẵn ở mọi màn khác qua `formatDateTime`). Chưa có component nào trong
 * app làm việc này (đã rà `fromNow`/`react-timeago`, không thấy) nên tạo mới ở đây để dùng chung,
 * thay vì mỗi màn viết lặp lại.
 *
 * ⚠️ Dòng tương đối dùng locale MẶC ĐỊNH của moment (tiếng Anh: "3 hours ago"), cố ý.
 *
 *    Bản trước có `import 'moment/locale/vi'` để `.locale('vi')` ra tiếng Việt. Nhưng nạp file
 *    locale của moment là ĐẶT LUÔN locale toàn cục — cả app đang chạy `en`, nên một dòng import ở
 *    đây đã lặng lẽ đổi định dạng ngày của những màn không liên quan: `Home/StatisticsByDays.js`
 *    (`format('dddd')` → "thứ hai") và `IssuesManagementReport/TableStorePackage.js`
 *    (`format('MMMM YYYY')` → "tháng 9 2026"). Locale `vi` còn có `dow: 1` thay vì `dow: 0`, nên
 *    mọi `startOf('week')` về sau lệch một ngày.
 *
 *    Chỉ gọi `.locale('vi')` trên instance mà KHÔNG import thì cũng vô nghĩa: CRA loại toàn bộ
 *    locale khỏi bundle (`webpack.IgnorePlugin(/^\.\/locale$/, /moment$/)` trong
 *    `react-scripts/config/webpack.config.js`), nên `.locale('vi')` im lặng rơi về `en`. Giữ lại
 *    lời gọi đó chỉ khiến người đọc tưởng đang có tiếng Việt.
 *
 *    Muốn tiếng Việt mà không đụng global thì phải import rồi `moment.locale('en')` ngay sau đó,
 *    hoặc tự dựng chuỗi tương đối không qua locale của moment.
 *
 * Dòng dưới là mốc tuyệt đối `DD/MM/YYYY HH:mm` qua `formatDateTime`, không phụ thuộc locale.
 */
function TimeAgo({value}) {
    if (!value) return <span className="VcMuted">{DASH}</span>

    return (
        <div className="VcTimeAgo">
            <div>{moment(value).fromNow()}</div>
            <div className="VcMuted VcTimeAgo__absolute">{formatDateTime(value)}</div>
        </div>
    )
}

TimeAgo.propTypes = {
    /** Bất cứ thứ gì `moment()` nhận được: chuỗi ISO, `Date`, hay số ms. Rỗng → dấu gạch. */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
}

export default TimeAgo
